import {
  NpaPropertiesIcon,
  NpaInquiriesIcon,
  RecordIcon,
  UserIcon,
  SubscriptionIcon,
  BannerIcon,
  MapIcon,
  JantriIcon,
  SettingIcon,
  IntroScreenIcon,
  MarketPlaceIcon,
  PublicPropertyIcon,
  PublicLandIcon,
} from "../assets/icons";
import { MessageSquareText } from "lucide-react";
import { routes } from "../routes/pageRoutes";

export const SidebarContent = [
  {
    title: "User",
    module: "user_management",
    icon: <UserIcon size={18} />,
    children: [
      {
        title: "R-Point Users",
        icon: <RecordIcon size={10} />,
        link: routes.userRPoint,
        matchRoutes: [routes.userRPoint, routes.viewUser, routes.viewAllProducts],
      },
      {
        title: "MEP Users",
        icon: <RecordIcon size={10} />,
        link: routes.userMep,
        matchRoutes: [routes.userMep, routes.viewUser, routes.viewAllProducts],
      },
    ],
  },
  {
    title: "Company",
    module: "company_management",
    icon: <svg width={18} height={18} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path d="M16 10L18.1494 10.6448C19.5226 11.0568 20.2092 11.2628 20.6046 11.7942C21 12.3256 21 13.0425 21 14.4761V22" stroke="currentColor" strokeWidth="1.5" strokeLinejoin="round" />
      <path d="M8 9H11M8 13H11" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
      <path d="M12 22V19C12 18.0572 12 17.5858 11.7071 17.2929C11.4142 17 10.9428 17 10 17H9C8.05719 17 7.58579 17 7.29289 17.2929C7 17.5858 7 18.0572 7 19V22" stroke="currentColor" strokeWidth="1.5" strokeLinejoin="round" />
      <path d="M2 22H22" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" />
      <path d="M3 22V6.71724C3 4.20649 3 2.95111 3.79118 2.32824C4.58237 1.70537 5.74742 2.04355 8.07752 2.7199L13.0775 4.17122C14.4836 4.57937 15.1867 4.78344 15.5933 5.33965C16 5.89587 16 6.65344 16 8.16857V22" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
    </svg>,
    children: [
      {
        title: "All Companies",
        icon: <RecordIcon size={10} />,
        link: routes.allCompanies,
        matchRoutes: [
          routes.allCompanies,
          routes.viewCompany,
          routes.viewAllCompany,
          routes.viewCompanyAllProducts,
          routes.viewAllPortfolios,
          routes.viewPortfolio,
          routes.addPortfolio,
        ],
      },
      {
        title: "Verification Requests",
        module: "company_verification",
        icon: <RecordIcon size={10} />,
        link: routes.verificationRequests,
        matchRoutes: [routes.verificationRequests, routes.viewVerificationRequests],
      },
    ],
  },
  {
    title: "Subscription",
    module: "subscription_plans",
    icon: <SubscriptionIcon size={18} />,
    children: [
      {
        title: "Feature Management",
        icon: <RecordIcon size={10} />,
        link: routes.subscriptionFeatures,
      },
      {
        title: "Plan Management",
        icon: <RecordIcon size={10} />,
        link: routes.subscriptionPlans,
        matchRoutes: [routes.subscriptionPlans, routes.addSubscriptionPlan, routes.editSubscriptionPlan],
      },
      {
        title: "Subscriptions",
        icon: <RecordIcon size={10} />,
        link: routes.userSubscription,
      },
      {
        title: "Payment",
        icon: <RecordIcon size={10} />,
        link: routes.subscriptionPayments,
      },
      {
        title: "GIS Trial",
        icon: <RecordIcon size={10} />,
        link: routes.gisTrial,
      },
    ],
  },
  {
    // No module on the group: each product is its own permission, so an admin
    // sees only the screens they may read, and the group hides when neither.
    title: "Feedback",
    icon: <MessageSquareText size={18} />,
    children: [
      {
        title: "R-Point",
        module: "feedback_rpoint",
        icon: <RecordIcon size={10} />,
        link: routes.feedbackRpoint,
      },
      {
        title: "MyEstatePoint",
        module: "feedback_mep",
        icon: <RecordIcon size={10} />,
        link: routes.feedbackMep,
      },
    ],
  },
  {
    title: "Jantri",
    key: "JANTRI_DYNAMIC",
    module: "map_jantri",
    icon: <JantriIcon size={18} />,
    children: [],
  },
  {
    title: "Map",
    key: "MAP_DYNAMIC",
    module: "map_jantri",
    icon: <MapIcon size={18} />,
    children: [],
  },
  {
    title: "Map Georeferences",
    module: "map_jantri",
    icon: <MapIcon size={18} />,
    link: routes.mapGeoreferenceList,
    matchRoutes: [routes.mapGeoreferenceList, routes.mapGeoreference, routes.mapGeoreferenceImport, routes.mapGeoreferenceImportDetail],
  },
  {
    title: "Banner",
    module: "banner",
    icon: <BannerIcon size={18} />,
    link: routes.banner,
    matchRoutes: [routes.banner, routes.addBanner, routes.editBanner],
  },
  {
    title: "NPA",
    module: "npa_properties",
    icon: <NpaPropertiesIcon size={18} />,
    children: [
      {
        title: "NPA Properties",
        icon: <NpaPropertiesIcon size={18} />,
        link: routes.npaProperties,
        matchRoutes: [routes.npaProperties, routes.addNpaProperties, routes.editNpaProperties, routes.viewNpaProperties],
      },
      {
        title: "NPA Inquiries",
        icon: <NpaInquiriesIcon size={18} />,
        link: routes.npaInquiries,
      },

      {
        title: "Bank Manage",
        module: "banks",
        icon: <svg width={18} height={18} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
          <path d="M12.125 5.75H12M12.25 5.75C12.25 5.88807 12.1381 6 12 6C11.8619 6 11.75 5.88807 11.75 5.75C11.75 5.61193 11.8619 5.5 12 5.5C12.1381 5.5 12.25 5.61193 12.25 5.75Z" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
          <path d="M5 9V19M9 9V19" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
          <path d="M15 9V19M19 9V19" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
          <path d="M21.3518 9H2.64822C2.29022 9 2 8.70651 2 8.34447C2 8.12259 2.11099 7.91577 2.29495 7.79485L8.73007 3.56485C10.3171 2.52162 11.1107 2 12 2C12.8893 2 13.6829 2.52162 15.2699 3.56485L21.7051 7.79485C21.889 7.91577 22 8.12259 22 8.34447C22 8.70651 21.7098 9 21.3518 9Z" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
          <path d="M21.0397 20.2929L20.3519 19.5858C20.0707 19.2968 19.9301 19.1522 19.7514 19.0761C19.5726 19 19.3738 19 18.9762 19H5.02382C4.62621 19 4.4274 19 4.24863 19.0761C4.06987 19.1522 3.92929 19.2968 3.64814 19.5858L2.9603 20.2929C2.25356 21.0194 1.9002 21.3827 2.02456 21.6913C2.14893 22 2.64867 22 3.64814 22H20.3519C21.3513 22 21.8511 22 21.9754 21.6913C22.0998 21.3827 21.7464 21.0194 21.0397 20.2929Z" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
        </svg>,
        children: [
          {
            title: "Banks",
            icon: <RecordIcon size={10} />,
            link: routes.banks,
            matchRoutes: [routes.banks, routes.viewBanksDetail],
          },
          {
            title: "Bank Users",
            icon: <RecordIcon size={10} />,
            link: routes.bankUsers,

          },
        ],
      },
    ],
  },
  {
    title: "Public Properties",
    module: "broker_properties",
    icon: <PublicPropertyIcon size={18} />,
    link: routes.publicProperties,
    matchRoutes: [routes.publicProperties],
  },
  {
    title: "Public Lands",
    module: "broker_properties",
    icon: <PublicLandIcon size={18} />,
    link: routes.publicLands,
    matchRoutes: [routes.publicLands],
  },
  {
    title: "Setting",
    module: "ad_config",
    icon: <SettingIcon size={18} />,
    link: routes.setting,
  },
  {
    title: "Marketplace",
    module: "marketplace_listings",
    icon: <MarketPlaceIcon size={18} />,
    children: [
      {
        title: "User Listing",
        icon: <RecordIcon size={10} />,
        link: routes.marketplaceListings,
        matchRoutes: [routes.marketplaceListings, routes.viewMarketplaceListing],
      },
      {
        title: "Bulk Offer",
        icon: <RecordIcon size={10} />,
        link: routes.marketplaceBulkOffers,
        matchRoutes: [
          routes.marketplaceBulkOffers,
          routes.createMarketplaceBulkOffer,
          routes.editMarketplaceBulkOffer,
          routes.viewMarketplaceBulkOffer,
        ],
      },
      {
        title: "Categories",
        icon: <RecordIcon size={10} />,
        link: routes.marketplaceCategories,
      },
      {
        title: "Bulk Offer Requests",
        icon: <RecordIcon size={10} />,
        link: routes.marketplaceBulkOfferRequests,
      },
      {
        title: "Bookings",
        icon: <RecordIcon size={10} />,
        link: routes.marketplaceBookings,
        matchRoutes: [routes.marketplaceBookings, routes.viewMarketplaceBooking],
      },
      {
        title: "Requirements",
        icon: <RecordIcon size={10} />,
        link: routes.marketplaceRequirements,
      },
    ],
  },
  {
    title: "Intro Screens",
    module: "intro_screens",
    icon: <IntroScreenIcon size={18} />,
    link: routes.introductionScreens,
    matchRoutes: [routes.introductionScreens, routes.addIntroductionScreen, routes.editIntroductionScreen],
  },
  {
    title: "Profile Suggestions",
    module: "profile_suggestion_cards",
    icon: <svg width={18} height={18} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path d="M13 3.00231C12.5299 3 12.0307 3 11.5 3C7.02166 3 4.78249 3 3.39124 4.39124C2 5.78249 2 8.02166 2 12.5C2 16.9783 2 19.2175 3.39124 20.6088C4.78249 22 7.02166 22 11.5 22C15.9783 22 18.2175 22 19.6088 20.6088C21 19.2175 21 16.9783 21 12.5C21 11.9693 21 11.4701 20.9977 11" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" />
      <path d="M18.5 2L18.7579 2.69703C19.0961 3.61102 19.2652 4.06802 19.5986 4.40139C19.932 4.73477 20.389 4.90387 21.303 5.24208L22 5.5L21.303 5.75792C20.389 6.09613 19.932 6.26524 19.5986 6.59861C19.2652 6.93198 19.0961 7.38898 18.7579 8.30297L18.5 9L18.2421 8.30297C17.9039 7.38898 17.7348 6.93198 17.4014 6.59861C17.068 6.26524 16.611 6.09613 15.697 5.75792L15 5.5L15.697 5.24208C16.611 4.90387 17.068 4.73477 17.4014 4.40139C17.7348 4.06802 17.9039 3.61102 18.2421 2.69703L18.5 2Z" stroke="currentColor" strokeWidth="1.5" strokeLinejoin="round" />
      <path d="M7 17.5C9.3317 15.0578 13.6432 14.9428 16 17.5M13.9951 10C13.9951 11.3807 12.8742 12.5 11.4915 12.5C10.1089 12.5 8.98797 11.3807 8.98797 10C8.98797 8.61929 10.1089 7.5 11.4915 7.5C12.8742 7.5 13.9951 8.61929 13.9951 10Z" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" />
    </svg>,
    link: routes.profileSuggestionCards,
  },
  {
    title: "Broker CRM",
    module: "broker_crm",
    icon: <svg width={18} height={18} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path d="M17 17C15.6193 17 14.5 15.8807 14.5 14.5C14.5 13.1193 15.6193 12 17 12C18.3807 12 19.5 13.1193 19.5 14.5C19.5 15.8807 18.3807 17 17 17ZM17 17C19.4853 17 21.5 19.0147 21.5 21.5M17 17C14.5147 17 12.5 19.0147 12.5 21.5" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
      <path d="M7 7.5C5.61929 7.5 4.5 6.38071 4.5 5C4.5 3.61929 5.61929 2.5 7 2.5C8.38071 2.5 9.5 3.61929 9.5 5C9.5 6.38071 8.38071 7.5 7 7.5ZM7 7.5C9.48528 7.5 11.5 9.51472 11.5 12M7 7.5C4.51472 7.5 2.5 9.51472 2.5 12" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
      <path d="M3.5 15.5C3.5 18.2643 5.73571 20.5 8.5 20.5L8 18.5" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
      <path d="M18.5 8.5C18.5 5.73571 16.2643 3.5 13.5 3.5L14 5.5" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
    </svg>
    ,
    children: [
      {
        title: "Properties",
        module: "broker_properties",
        icon: <RecordIcon size={10} />,
        link: routes.brokerProperties,
        matchRoutes: [routes.brokerProperties, routes.addBrokerProperty, routes.editBrokerProperty, routes.viewBrokerProperty],
      },
      {
        title: "Clients",
        module: "broker_clients",
        icon: <RecordIcon size={10} />,
        link: routes.brokerClients,
        matchRoutes: [routes.brokerClients],
      },
    ],
  },
  {
    title: "Admin Management",
    icon: <svg width={18} height={18} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path d="M14 8.5C14 5.73858 11.7614 3.5 9 3.5C6.23858 3.5 4 5.73858 4 8.5C4 11.2614 6.23858 13.5 9 13.5C11.7614 13.5 14 11.2614 14 8.5Z" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
      <path d="M16 20.5C16 16.634 12.866 13.5 9 13.5C5.13401 13.5 2 16.634 2 20.5" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
      <path d="M19 14V15.5M19 10C19.737 10 20.3809 10.3987 20.7278 10.9921C20.9009 11.288 21 11.6324 21 12C21 12.3676 20.9009 12.7119 20.7278 13.0079C20.3809 13.6013 19.737 14 19 14M19 10C18.263 10 17.6191 10.3987 17.2722 10.9921C17.0992 11.288 17 11.6324 17 12C17 12.3676 17.0991 12.712 17.2722 13.0079C17.6191 13.6013 18.263 14 19 14M20.7278 13.0079L22 13.75M17.2722 13.0079L16 13.75M19 10V8.5M20.7278 10.9921L22 10.25M17.2722 10.9921L16 10.25" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
    </svg>,
    children: [
      {
        title: "Roles",
        module: "admin_roles",
        icon: <RecordIcon size={10} />,
        link: routes.roles,
        matchRoutes: [routes.roles],
      },
      {
        title: "Users",
        module: "admin_users",
        icon: <RecordIcon size={10} />,
        link: routes.adminUsers,
        matchRoutes: [routes.adminUsers],
      },
    ],
  },
];
